import uk from './uk.json';
import ru from './ru.json';
import en from './en.json';
import de from './de.json';
import pl from './pl.json';

// Extra typing is necessary to check is all localizations has the same fields
export const localizationResources: Record<string, typeof uk & typeof ru & typeof en & typeof de & typeof pl> = {
	uk,
	ru,
	en,
	de,
	pl,
};
